<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show === true">ทำรายการสรุปยอดเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2 text-right">
            <v-btn color="#28ab28" class="white--text" @click="open_summary = true" width="20%" height="65">
                ทำรายการสรุปยอด
            </v-btn>
        </div>
        <v-card>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item="dataDetail">
                    <tr>
                        <td width="10%">{{dataDetail.item.number}}</td>
                        <td width="25%">{{dataDetail.item.name}}</td>
                        <td width="15%">{{dataDetail.item.type_work}}</td>
                        <td width="20%">{{dataDetail.item.user_name}}</td>
                        <td width="15%">
                            <v-btn color="warning" v-if="dataDetail.item.status == 0" @click="openConfirmStatus(dataDetail.item.id)">กำลังดำเนินการ</v-btn>
                            <div class="success--text" v-if="dataDetail.item.status == 1">
                                สำเร็จ
                            </div>
                        </td>
                        <td width="15%">
                            <span class="cursor_summary_list" @click="detailPage(dataDetail.item.id,dataDetail.item.type_work)">
                                <v-icon right color="grey">mdi-eye</v-icon>
                            </span>
                            <span class="cursor_summary_list" @click="editPage(dataDetail.item.id,dataDetail.item.type_work)">
                                <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                            </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="open_summary" persistent max-width="600px">
            <v-card>
                <v-form ref="form" @submit.prevent="addTypeFood()">
                    <v-card-title class="justify-space-between">
                        <div>
                            ทำรายการสรุปยอด
                        </div>
                        <div class="cursor_summary_list" @click="open_summary = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="6">
                                    <v-card class="pa-3 card_link_summary_list" @click="$router.push('/parttimesummary')">
                                        <div class="image_summary_list">
                                            <img src="@/assets/follow.png">
                                        </div>
                                        <div class="text_summary_list text-center">พาร์ทไทม์</div>
                                    </v-card>
                                </v-col>
                                <v-col cols="6">
                                    <v-card class="pa-3 card_link_summary_list" @click="$router.push('/employeesummary')">
                                        <div class="image_summary_list">
                                            <img src="@/assets/follow.png">
                                        </div>
                                        <div class="text_summary_list text-center">พนักงาน</div>
                                    </v-card>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>

                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="open_confirm_status" persistent max-width="600">
            <v-card>
                <v-card-title>
                    ยืนยันรายการสรุปยอด
                </v-card-title>

                <v-card-text>
                    ท่านต้องการยืนยันรายการสรุปยอด ใช่ หรือ ไม่ ?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" height="50" @click="changeStatus()">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" height="50" @click="open_confirm_status = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import summary from '@/api/team/teamreportsummary/summary.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show: false,
            open_summary: false,
            open_confirm_status: false,
            search: '',
            edit_id: null,
            headers: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },
                {
                    text: 'รายการ',
                    value: 'name'
                },
                {
                    text: 'ประเภท',
                    value: 'type_work'
                },
                {
                    text: 'ทำรายการโดย',
                    value: 'user_name'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        async summaryList() {
            this.loading_page = true
            this.data = []
            summary.summaryList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.list
                    response.data.list.forEach((detail, index) => {
                        this.data[index]['number'] = index + 1
                    })
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async openConfirmStatus(id) {
            this.edit_id = id
            this.open_confirm_status = true
        },
        async changeStatus() {
            this.open_confirm_status = false
            this.loading_page = true
            summary.summaryStatus(this.edit_id).then((response) => {
                if (response.data.successful === true) {
                    this.summaryList()
                    this.alert_show = true
                    setTimeout(() => this.alert_show = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async detailPage(id, type) {
            const idPage = {
                id: id
            }
            if (type == 'พาร์ทไทม์') {
                this.$store.commit('detailPartTimeSummaryPage', idPage)
                this.$router.push('/detailparttimesummary')
            }
            if (type == 'พนักงาน') {
                this.$store.commit('detailEmployeeSummaryPage', idPage)
                this.$router.push('/detailemployeesummary')
            }
        },
        async editPage(id, type) {
            const idPage = {
                id: id
            }
            if (type == 'พาร์ทไทม์') {
                this.$store.commit('editPartTimeSummaryPage', idPage)
                this.$router.push('/editparttimesummary')
            }
            if (type == 'พนักงาน') {
                this.$store.commit('editEmployeeSummaryPage', idPage)
                this.$router.push('/editemployeesummary')
            }
        },
    },
    mounted() {
        this.summaryList()
    }
}
</script>

<style scoped>
.cursor_summary_list {
    cursor: pointer;
}

.image_summary_list {
    margin: auto;
    width: 50px;
}

.image_summary_list>img {
    max-width: 100%;
}

.text_summary_list {
    font-size: 22px;
}

.card_link_summary_list:hover {
    color: #fff;
    background: #28ab28;
    transition: 0.1s;
}
</style>
